import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RutPipe, RutValidator } from 'ng2-rut';
import { getErrorMessage } from 'src/app/shared/helpers/validationMessages';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Router } from '@angular/router';
import { paths } from 'src/app/shared/helpers/constants';
import { getRut } from 'src/app/shared/helpers/helper';

enum States {
  start = 1,
  rutSuccess = 2,
  fnSuccess = 3,
  error = 4,
}

@Component({
  selector: 'app-recuperar-clave',
  templateUrl: './recuperar-clave.component.html',
  styleUrls: ['./recuperar-clave.component.sass'],
})
export class RecuperarClaveComponent implements OnInit {
  public pwdRequestForm: FormGroup;
  private rutPipe: RutPipe;
  states = States;
  status = States.start;
  displayEmail: string;
  fechaMax: Date;

  getErrorMessage = getErrorMessage;
  get username() {
    return this.pwdRequestForm.get('username');
  }
  get fn() {
    return this.pwdRequestForm.get('fn');
  }

  public formErrors = {
    username: '',
  };

  emptyRut(control) {
    const { value } = control;
    return value
      ? null
      : {
          emptyRut: {
            valid: false,
          },
        };
  }

  constructor(
    formBuilder: FormBuilder,
    private authService: AuthService,
    rutValidator: RutValidator,
    private router: Router
  ) {
    this.pwdRequestForm = formBuilder.group({
      username: ['', { validators: [this.emptyRut, rutValidator] }],
      fn: ['', { validators: [Validators.required] }],
    });
    this.rutPipe = new RutPipe();
  }

  lostFocus() {
    this.pwdRequestForm
      .get('username')
      .setValue(
        this.rutPipe.transform(this.pwdRequestForm.get('username').value)
      );
  }

  ngOnInit() {
    const Dateaux = new Date('2015/12/31 22:00:00');
    this.fechaMax = Dateaux;
  }

  goToLogin() {
    this.router.navigate([paths.login.path]);
  }

  requestPassword() {
    if (!this.pwdRequestForm.dirty || !this.pwdRequestForm.valid) {
      return;
    }
    const username = this.pwdRequestForm.get('username').value;
    const user = getRut(username);
    const fn = this.pwdRequestForm.get('fn').value;
    this.authService.validateUserDate(user, fn).subscribe(
      res => {
        if (res) {
          this.authService.requestPassword(user).subscribe(
            response => {
              this.status = States.fnSuccess;
              this.displayEmail = response.Email;
            },
            error => {
              this.status = States.error;
            }
          );
        } else {
          this.status = States.error;
        }
      },
      error => {
        this.status = States.error;
      }
    );
  }
}
